const interactiveExperienceServiceUrl = "https://interactive-experience.test-creator-tools.siriusxm.com";

export const environment = {
    interactiveExperienceServiceUrl,
    cognito: {
        userPoolId: "us-east-2_DWQCmKZMN",
        userPoolClientId: "5j4op9qtadkvh9vf7o6nc3elev",
        oauthDomain: "app-crt-tools-interactive-experience-service-test-auth.auth.us-east-2.amazoncognito.com",
        redirectSignIn: "https://interactive-experience-ui.test-creator-tools.siriusxm.com/auth/callback",
        redirectSignOut: "https://interactive-experience-ui.test-creator-tools.siriusxm.com/"
    }
};
